import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad, {
  error: '//static.loklok.video/img/default-sq.png',
  loading: '//static.loklok.video/img/default-sq.png',
  lazyComponent: true,
  throttleWait: 500,
  observer: true,
  filter: {
    webp(listener, options) {
      const domain = /.rr.tv|.fqdy.pro|.netpop.app/
      const isCDN = domain.test(listener.src)
      const hasParams = listener?.src?.indexOf('?') > -1
      if (!isCDN) {
        listener.src = listener?.src?.split('?')[0]
        return
      }
      // listener.src = listener.src.replace('http://', 'https://')
      if (options.supportWebp) {
        if (hasParams) {
          listener.src += '/format/webp'
          return
        }
        listener.src += '?imageMogr2/format/webp'
        return
      }
      // 不支持webp
      if (hasParams) {
        listener.src += '/format/jpg/size-limit/25k!'
        return
      }
      listener.src += '?imageMogr2/format/jpg/size-limit/25k!'
    }
  }
})
